'use strict';

// eslint-disable-next-line max-lines-per-function, max-params
angular.module('webAgro1App').factory('RelatorioVisitaCustomizadoService', function($rootScope,
  $compile, $http, $q, $templateCache, $timeout) {
  return {
    getConteudoTemplate: function(item) {
      const deferred = $q.defer();
      let template = null;
      const scope = $rootScope.$new();

      if (TIPOS_OPERACAO_OCORRENCIAS.indexOf(item.tipo) >= 0) {
        item.objeto.selectedItems.forEach(function(selectedItem) {
          selectedItem.indicadores = selectedItem.indicadores || [];
          if (selectedItem.indicadores.length === 0) {
            selectedItem.situacao = TYPES_STATUS_OPERATIONS.equilibrio;
          } else {
            selectedItem.situacao = selectedItem.indicadores.reduce(function(previous, indicador) {
              if (indicador.situacao && indicador.situacao.id > previous.situacao.id) {
                return indicador;
              }
              return previous;
            }, { situacao: TYPES_STATUS_OPERATIONS.equilibrio }).situacao;
          }
        });
        template = $templateCache.get('views/relatorio_visita_customizado/templates/_ocorrencia.html');
      } else {
        template = $templateCache.get(`views/relatorio_visita_customizado/templates/_${item.tipo}.html`);
      }

      scope.registro = item;
      const conteudo = $compile(template)(scope);

      $timeout(function() {
        deferred.resolve(conteudo[0].outerHTML);
      });

      return deferred.promise;
    }
  };
});
